import React from "react";
import { Reveal, SectionHeading } from "./_shared";
import { Briefcase, UserCog, Users, Building2 } from "lucide-react";

const profiles = [
    { icon: Briefcase, title: "Imprenditori e titolari d'azienda", text: "Per avere una visione chiara e sintetica di ciò che riguarda l'organizzazione." },
    { icon: UserCog, title: "Responsabili aziendali e amministrativi", text: "Per coordinare adempimenti, priorità e informazioni operative." },
    { icon: Users, title: "Responsabili risorse umane e referenti interni", text: "Per gestire in modo ordinato formazione, visite mediche e documenti dei lavoratori." },
    { icon: Building2, title: "Aziende che vogliono digitalizzare", text: "Per eliminare i registri cartacei e adottare documenti e dossier in formato digitale." },
];

export default function Audience() {
    return (
        <section id="audience" className="py-24 md:py-32 bg-white">
            <div className="max-w-[1400px] mx-auto px-5 md:px-8">
                <SectionHeading
                    chapter={5}
                    chapterLabel="A chi è rivolta"
                    title={
                        <>
                            Pensata per chi deve avere{" "}
                            <span className="text-gold-500">tutto sotto controllo</span>
                            {" "}e vuole eliminare i registri cartacei.
                        </>
                    }
                />
                <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-14">
                    {profiles.map((p, i) => {
                        const Icon = p.icon;
                        return (
                            <Reveal key={p.title} delay={i * 0.08}>
                                <div
                                    data-testid={`audience-${i}`}
                                    className="h-full rounded-3xl p-7 bg-navy-50 hover:bg-white border border-navy-100 hover-lift transition-all"
                                >
                                    <div className="w-14 h-14 rounded-2xl bg-navy-950 text-gold-400 flex items-center justify-center mb-6">
                                        <Icon size={26} strokeWidth={1.6} />
                                    </div>
                                    <h3 className="font-display font-bold text-navy-950 text-lg leading-snug">{p.title}</h3>
                                    <p className="mt-3 text-navy-600 text-sm leading-relaxed">{p.text}</p>
                                </div>
                            </Reveal>
                        );
                    })}
                </div>
                <Reveal delay={0.3}>
                    <p className="mt-14 text-center text-navy-600 text-lg max-w-3xl mx-auto">
                        Durante l'evento del <strong className="text-navy-950">1° ottobre 2026</strong> mostreremo come SafetyDesk81 può supportare le aziende che vogliono semplificare e digitalizzare la gestione degli adempimenti.
                    </p>
                </Reveal>
            </div>
        </section>
    );
}
